import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, DatePicker, Form, Input, Modal,
} from 'framework-ui-components';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

import { trasmettiManualmente } from 'apis/successioniApi';

class ModaleTrasmissioneManuale extends Component {
  constructor(props) {
    super(props);

    this.state = {
      DataRicevuta: null,
      NumeroProtocollo: '',
      DataPrimaDichiarazione: null,
      NumeroPrimaDichiarazione: '',
      VolumePrimaDichiarazione: '',
      AnnoPrimaDichiarazione: '',
    };
    this.invia = this.invia.bind(this);
  }

  controllaNumeriESettaStato(d) {
    if (d.NumeroPrimaDichiarazione) {
      d.NumeroPrimaDichiarazione = d.NumeroPrimaDichiarazione.replace(/\D/g, '');
    }
    if (d.VolumePrimaDichiarazione) {
      d.VolumePrimaDichiarazione = d.VolumePrimaDichiarazione.replace(/\D/g, '');
    }
    if (d.AnnoPrimaDichiarazione) {
      d.AnnoPrimaDichiarazione = d.AnnoPrimaDichiarazione.replace(/\D/g, '');
    }
    this.setState(d);
  }

  invia() {
    if (this.form.valida()) {
      trasmettiManualmente(this.props.idDichiarazione, this.state.DataRicevuta, this.state.NumeroProtocollo, this.state.VolumePrimaDichiarazione,
        this.state.NumeroPrimaDichiarazione, this.state.AnnoPrimaDichiarazione, this.state.DataPrimaDichiarazione)
        .then((resp) => {
          if (resp.Success) {
            this.props.onClose();
            SnackbarManager.notifySuccess('Dichiarazione trasmessa manualmente');
          } else {
            SnackbarManager.notifyError(resp.DetectedProblems);
          }
        });
    }
  }

  render() {
    const { modello4, onClose } = this.props;
    const tipologia = modello4 ? '' : ' telematica';
    return (
      // eslint-disable-next-line react/jsx-filename-extension
      <Modal show onClose={onClose}>
        <Modal.Header>Trasmetti  manualmente</Modal.Header>
        <Modal.Body>
          <Form ref={(r) => this.form = r} stato={this.state} onChange={(d) => this.controllaNumeriESettaStato(d)}>
            <DatePicker validations={['required']} title="Data della ricevuta" name="DataRicevuta" />
            <Input validations={['required']} title="Numero di protocollo" name="NumeroProtocollo" />
            <br />
            <Input
              validations={['required', {
                rule: 'Range', minValue: 1, maxValue: 99999, message: 'Inserire un volume valido',
              }]}
              title={`Volume registrazione ${tipologia}`}
              name="VolumePrimaDichiarazione"
            />
            <Input
              validations={['required', {
                rule: 'Range', minValue: 1, maxValue: 999999, message: 'Inserire un numero valido',
              }]}
              title={`Numero registrazione ${tipologia}`}
              name="NumeroPrimaDichiarazione"
            />
            <Input
              validations={['required', {
                rule: 'Range', minValue: 1, maxValue: 9999, message: 'Inserire un valore valido',
              }]}
              title={`Anno registrazione ${tipologia}`}
              name="AnnoPrimaDichiarazione"
            />
            <DatePicker
              validations={['required']}
              title={`Data registrazione ${tipologia}`}
              name="DataPrimaDichiarazione"
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>Chiudi</Button>
          <Button primary onClick={this.invia}>Trasmetti</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleTrasmissioneManuale.propTypes = {
  idDichiarazione: PropTypes.string.isRequired,
  modello4: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModaleTrasmissioneManuale;
